import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../loading/Loading";
import Apis from "../../Apis";
import { showAlert } from '../../ui/dialog';
import { FiMap, FiFileText } from 'react-icons/fi';
import FormLayout, { SubmitBtn } from '../../ui/FormLayout';
import { InputField } from '../../ui/InputField';

const AlterarRota = () => {
    const [sigla, setSigla] = useState('');
    const [descricao, setDescricao] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const parametro = useParams();

    const alertaErro = (texto) => showAlert({ title: "Atenção", text: texto, icon: "error", dangerMode: true });

    useEffect(() => {
        setLoading(true);
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
            body: JSON.stringify({ "id": parametro.id })
        };
        fetch(Apis.urlListarOneRotas, requestOptions)
            .then(response => response.json())
            .then((result) => {
                if (result.retorno.sucesso) {
                    setDescricao(result.registros[0].descricao);
                    setSigla(result.registros[0].nome);
                } else {
                    alertaErro(result.retorno.mensagem);
                    navigate("/listar-rotas");
                }
                setLoading(false);
            });
    }, []);

    const handleSubmit = () => {
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
            body: JSON.stringify({ "id": parametro.id, "nome": sigla, "descricao": descricao })
        };
        fetch(Apis.urlAlterarRotas, requestOptions)
            .then(response => response.json())
            .then((result) => {
                if (result.retorno.sucesso) {
                    navigate(`/alerta-sucesso/${result.retorno.mensagem}&listar-rotas`);
                } else {
                    alertaErro(result.retorno.mensagem);
                }
            });
    };

    if (loading) return <Loading />;

    return (
        <FormLayout
            title="Alteração de Rota"
            icon={<FiMap />}
            subtitle="Atualize os dados da rota."
        >
            <InputField
                label="Nome da rota" icon={<FiMap />} required
                placeholder="Nome da rota"
                onChange={e => setSigla(e.target.value)} value={sigla}
            />
            <InputField
                label="Descrição" icon={<FiFileText />}
                placeholder="Descrição"
                onChange={e => setDescricao(e.target.value)} value={descricao}
            />
            <SubmitBtn onClick={handleSubmit}>Salvar Alterações</SubmitBtn>
        </FormLayout>
    );
};

export default AlterarRota;
